(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('payments-superadmin', {
            parent: 'app',
            url: '/payments-superadmin',
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.payments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/payments/payments-superadmin/payments-superadmin.html',
                    controller: 'PaymentsSuperadminController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'paymentDate,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('payments');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
